import type { Theme } from '@fluentui/react-components';
import { tokens as fluentTokens } from '@fluentui/react-components';

import type { CoreUIExtendedThemeColorTokenName } from './coreUITokens.types';
import type { CoreUITokensObject } from './tokens.types';

type FluentTokensObject = {
  [P in keyof Theme]: `var(--${P})`;
};

export const tokens = fluentTokens as FluentTokensObject;

type AllColorTokenKeys = Extract<keyof Theme, `color${string}`>;

type CoreUIColorTokensObject = CoreUITokensObject<'extendedThemeToken', CoreUIExtendedThemeColorTokenName>;

export type ColorToken =
  | FluentTokensObject[AllColorTokenKeys]
  | CoreUIColorTokensObject[CoreUIExtendedThemeColorTokenName];
export type FUI9ColorToken = FluentTokensObject[AllColorTokenKeys];
